import Api from '../index';
import { endpoints } from '../endpoints';

export default class TransApi extends Api {
    common(data) {
        console.log('ddddd', data)
        let url = this.buildUrl(endpoints.trans.common, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    commonGet(data) {
        console.log("commonGetdata->", data)
        let url = this.buildUrl(endpoints.trans.commonGet, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    fundDetail(data) {
        let url = this.buildUrl(endpoints.preLogin.FundCategory, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    getSIPScheme(data) {
        let url = this.buildUrl(endpoints.extra.GetSchemeDetForSIPDashboard, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    getSchemeName(data) {
        let url = this.buildUrl(endpoints.extra.getSchemeName, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    checkCookies(data) {
        let url = this.buildUrl(endpoints.checkCookies, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    getAIFDetails(data) {
        let url = this.buildUrl(endpoints.cart.getAIFDetails)
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }

    getBankDetails(data) {
        let url = this.buildUrl(endpoints.cart.getBankDetails)
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    saveTransaction(data) {
        let url = this.buildUrl(endpoints.cart.saveTransaction)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    confirmTransaction(data) {
        let url = this.buildUrl(endpoints.cart.confirmTransaction)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    GetEmandateDetails(data) {
        let url = this.buildUrl(endpoints.GetEmandateDetails)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    SaveEmandateToken(data) {
        let url = this.buildUrl(endpoints.SaveEmandateToken)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    SaveEmandateResponse(data) {
        let url = this.buildUrl(endpoints.SaveEmandateResponse)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    GetAIFMOH(data) {
        let url = this.buildUrl(endpoints.GetAIFMOH)
        return this.fetch(url, "GET").then(response => response);
    }
}
